import FaqGutTab from './FaqGutTab'

export default FaqGutTab
